"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _A = _interopRequireDefault(require("../A"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: auto;\n\tmargin-left: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.div(_templateObject());

Container.displayName = 'Container';

var LinkContainer = _styledComponents.default.div(_templateObject2(), _spacing.default.s6);

LinkContainer.displayName = 'LinkContainer';

var EmployeeCard = function EmployeeCard(_ref) {
  var name = _ref.name,
      imageHref = _ref.imageHref,
      link = _ref.link,
      category = _ref.category,
      action = _ref.action,
      _onClick = _ref.onClick,
      rest = _objectWithoutPropertiesLoose(_ref, ["name", "imageHref", "link", "category", "action", "onClick"]);

  return _react.default.createElement(Container, rest, _react.default.createElement(_Avatar.default, {
    employeeName: name,
    employeeImageHref: imageHref
  }), _react.default.createElement(LinkContainer, null, _react.default.createElement(_A.default, {
    onClick: function onClick() {
      _reactGa.default.event({
        category: category,
        action: action
      });

      if (_onClick) {
        _onClick();
      }
    },
    href: link
  }, name)));
};

EmployeeCard.propTypes = {
  name: _propTypes.string.isRequired,
  imageHref: _propTypes.string,
  link: _propTypes.string.isRequired,
  category: _propTypes.string,
  action: _propTypes.string,
  onClick: _propTypes.func
};
EmployeeCard.defaultProps = {
  imageHref: undefined,
  category: 'Employee',
  action: 'Employee card name is clicked',
  onClick: undefined
};
var _default = EmployeeCard;
exports.default = _default;